import { createAction } from "@coverme/redux";
import { stringify } from "@coverme/querystring";
import Axios from "axios";

export const getLookups = (customerId, jurisdictions) => {
    if (jurisdictions.length === 0) {
        jurisdictions = ["MS"];
    }
    return createAction("GET_LOOKUPS", () =>
        Axios.get(`/api/customer/${customerId}/encounter/${jurisdictions[0]}/constants`).then(data => ({
            customerJurisdictions: jurisdictions,
            lookups: data.data,
        }))
    );
};

export const getProgramSections = encounterId => {
    return createAction("GET_PROGRAM_SECTIONS", (dispatch, getState) => {
        const jurisdictions = getState().customer.data.jurisdictions;
        const customerId = getState().customer.data.customer.GlobalId;
        const queryString = stringify(jurisdictions);
        return Axios.get(`/api/customer/${customerId}/encounter/${encounterId}/sections/programs?${queryString}`).then(data => data.data);
    });
};

export const getStates = customerJurisdictions => {
    return createAction("GET_STATES", () =>
        Axios.get("/api/jurisdictions").then(data => ({
            states: data.data,
            customerJurisdictions: customerJurisdictions,
        }))
    );
};
